import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { EditChargingStationProfileDialogComponent } from '../../../dialog/edit-chargingstationprofiles-dialog/edit-chargingstationprofile-dialog.component';
@Component({
  selector: 'app-edit-chargingstationprofiles',
  templateUrl: './edit-chargingstationprofiles.component.html',
  styleUrls: ['./edit-chargingstationprofiles.component.scss']
})
export class EditChargingstationprofilesComponent implements OnInit {

  constructor(public dialog: NgbModal, private router: Router, private activatedRoute: ActivatedRoute) { }

  ngOnInit() {
    this.openDialog();
  }

  openDialog(): void {
    var modelId = this.activatedRoute.snapshot.params.key;
    const dialogRef = this.dialog.open(EditChargingStationProfileDialogComponent, { centered: true, backdrop: 'static', size:'lg' });

    dialogRef.componentInstance.modelId = modelId;

    dialogRef.result.then((result) => {
      this.router.navigate(['../../'], { relativeTo: this.activatedRoute });
    }, (backdrop) => {
      this.router.navigate(['../../'], { relativeTo: this.activatedRoute });
    });
  }

}
